var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recaptcha-container"},[_c('h3',[_vm._v("Verification")]),_c('p',[_vm._v("Please verify before proceeding to access page data.")]),_c('vue-recaptcha',{ref:"recaptcha",attrs:{"sitekey":_vm.siteKey,"loadRecaptchaScript":true},on:{"verify":_vm.onCaptchaVerified,"expired":_vm.onCaptchaExpired}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }